
import { weddingData } from '../lib/data';
import styles from './Wedding.module.scss';

const Wedding = () => {

    return (         
        <section >            
            <div className = {styles.container}>  
                {weddingData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="свадебная фотосессия Ставрополь" />
                    </div>
                ))}

            </div>
        </section>
    );
}

export default Wedding;